import { HOURS_DISPLAY } from '../config/constants';

export const faqs = [
    {
        question: 'What racing simulator equipment do you have?',
        answer: 'We feature the Logitech G29 racing wheel and pedal set for an immersive racing experience. Our setup includes a professional racing seat and high-quality display for the ultimate racing experience.',
        icon: 'fa-solid fa-car-rear'
    },
    {
        question: 'Where is Project Play By CW located?',
        answer: 'We are located in Bandar Sunway, Subang Jaya, Malaysia. Our gaming hub is easily accessible via public transportation, with BRT and LRT stations nearby.',
        icon: 'fa-solid fa-location-dot'
    },
    {
        question: 'What gaming services do you offer?',
        answer: 'We offer three main services: Racing Simulators, High-Performance PC Gaming, and PlayStation 5 gaming. Each service is equipped with top-tier hardware and the latest games.',
        icon: 'fa-solid fa-gamepad'
    },
    {
        question: 'What are your operating hours?',
        answer: `We are open daily from ${HOURS_DISPLAY}. During peak hours and weekends, we recommend making a reservation to ensure availability.`,
        icon: 'fa-regular fa-clock'
    },
    {
        question: 'Do you offer membership benefits?',
        answer: 'Yes. Members enjoy exclusive rates, packages, and reload bonuses. Member rates are RM6/hour for PC gaming and RM12/hour for the racing simulator, compared with regular rates of RM8/hour and RM15/hour.',
        icon: 'fa-solid fa-crown'
    },
    {
        question: 'What PS5 games are available?',
        answer: 'We offer a variety of popular PS5 games including FC 25, UFC 5, Overcooked, NBA 2K24, and Tekken 8. Our game library is regularly updated with new releases.',
        icon: 'fa-solid fa-dice'
    },
    {
        question: 'Can I host events at Project Play?',
        answer: 'Yes. We welcome gaming events, tournaments, and group bookings. We have hosted events such as Monash Cup, featuring Counter-Strike 2, Valorant, and League of Legends.',
        icon: 'fa-solid fa-trophy'
    },
    {
        question: 'What are your PC specifications?',
        answer: 'Our gaming PCs are equipped with an AMD Ryzen 5 5500 processor, MSI GeForce RTX 3070 graphics card, 16 GB of DDR4-3200 memory, and 27-inch 165 Hz Samsung monitors.',
        icon: 'fa-solid fa-desktop'
    }
];
